import { Button } from '@monorepo/shared/componentsV2/Button';
import { ErrorBoundary } from '@monorepo/shared/componentsV2/ErrorBoundary';
import { BaseModal } from '@monorepo/shared/componentsV2/modals/BaseModal';
import { USAGE_TRACKING_PREFIX } from '@monorepo/shared/constants/usageTracking';
import arrayMutators from 'final-form-arrays';
import { FormTemplateAttribute } from 'mapistry-shared';
import React, { useMemo } from 'react';
import { Form } from 'react-final-form';
import { EditableFormTemplateField } from '../types';
import { EditFieldForm } from './EditFieldForm';

export type EditFieldModalProps = {
  field: EditableFormTemplateField;
  isInDuplicableSection: boolean;
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (field: EditableFormTemplateField) => void;
  isConditionTriggerField: boolean;
};

export function EditFieldModal({
  field,
  isInDuplicableSection,
  isOpen,
  onClose,
  onSubmit,
  isConditionTriggerField,
}: EditFieldModalProps) {
  const isInspectionDate = useMemo(
    () => field.attributes?.includes(FormTemplateAttribute.IS_INSPECTION_DATE),
    [field.attributes],
  );

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={field}
      subscription={{ invalid: true, pristine: true }}
      mutators={{ ...arrayMutators }}
    >
      {({ handleSubmit, pristine, invalid }) => (
        <BaseModal
          id={`${USAGE_TRACKING_PREFIX}-edit-form-template-field-modal`}
          title="Configure field details"
          open={isOpen}
          onClose={onClose}
          maxWidth="md"
          buttons={
            <>
              <Button color="primary" onClick={onClose} type="button">
                Cancel
              </Button>
              <Button
                color="primary"
                disabled={pristine || invalid}
                onClick={handleSubmit}
                type="submit"
                variant="contained"
              >
                Apply
              </Button>
            </>
          }
        >
          <ErrorBoundary>
            <EditFieldForm
              fieldType={field.type}
              isConditionTriggerField={isConditionTriggerField}
              conditionalRules={field.conditionalRules}
              isInDuplicableSection={isInDuplicableSection}
              isInspectionDate={isInspectionDate}
              isEditMode
            />
          </ErrorBoundary>
        </BaseModal>
      )}
    </Form>
  );
}
